import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'

export const MODEL_NAME = 'ClientsGet'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
